export default __webpack_public_path__ + "static/media/pagePhoto7.cf062b35.png";